/** UTC+3 */
export const TIME_ZONE_MOSCOW = 3;

/** Названия месяцев для склонения */
export const DECLINATION_OF_MONTHS = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];

/**
 * Сокращенные дни недели
 * Дни недели начинаются с Воскресенья под индексом 0, поэтому он идет первым
 */
export const WEEK_DAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

/**
 * Дни недели
 * Дни недели начинаются с Воскресенья под индексом 0, поэтому он идет первым
 */
export const WEEK_DAYS_FULL = [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
];

export const ERROR_PASSED_DATE_GREATEST_CURRENT =
    'Переданная дата не может быть больше чем текущая';

export const DEFAULT_EMPTY_SYMBOL = '–';
